"use client";

import "@/globals.css";

import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import { useEffect } from "react";
import { GlobalErrorDisplay } from "./[lang]/_components/GlobalErrorDisplay";
import { getLangFromPathname } from "./[lang]/_utils/get-lang-from-pathname";

export default function GlobalErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  const pathname = usePathname();
  const lang = getLangFromPathname(pathname) ?? "en";

  return (
    <html lang="en">
      <body>
        <div>
          <GlobalErrorDisplay lang={lang} reset={reset} />
        </div>
      </body>
    </html>
  );
}
